import axios from "axios";
import Cookies from "js-cookie";
import { CMSWAGER_CONFIG } from "helper/Constants";
import { API_URL } from "helper/Constants";
import { ENCRYPTION_OF_DATA } from "helper/Functions";


class SportbookService {
  constructor(baseURL) {
    //console.log("SPORTBOOK BASE URL : ", baseURL)
    this.api = axios.create({
      baseURL: baseURL || API_URL, // Ensure this is your correct backend URL
    });

    this.lastModified = null; // Store Last-Modified timestamp

    // Add an interceptor to handle token refresh
    this.api.interceptors.request.use(
      async(config) => {
        const token = Cookies.get("token");
        if (token) {
          config.headers["Authorization"] = `Bearer ${token}`;
        }
         if (config.data) {
                   config.headers["Content-Type"] = `application/json`;
                   config.data = await ENCRYPTION_OF_DATA(config.data);// Send the entire encrypted object
         }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Add a response interceptor to handle token refresh
    this.api.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config;

         if (error.response && (error.response.status === 401 && error.response.data.message !== "Invalid refresh token")) {
          try {
            const newToken = await this.refreshToken();
            if (newToken) {
              // Update the token in the request header
              originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
              return axios(originalRequest);
            }
          } catch (refreshError) {
            window?.location?.reload()
            return Promise.reject(refreshError);
          }
          
        }

        return Promise.reject(error);
      }
    );
  }
  async refreshToken() {
    try {
      const response = await this.api.post(
        "/auth/refresh-token",
        {},
        {
          withCredentials: true, // Optional: Use this if you still want to send cookies
        }
      );
      const newAccessToken = response.data.accessToken;
      Cookies.set("token", newAccessToken, {
        secure: true, // Only transmit over HTTPS in production
        sameSite: "None", // Required for cross-origin
      }); // Save the new token
      return newAccessToken;
    } catch (error) {
      Cookies.remove("user", { secure: true, sameSite: "None" });
      Cookies.remove("token", { secure: true, sameSite: "None" });
      Cookies.remove("refreshToken", { secure: true, sameSite: "None" });
      window?.location?.reload()
      console.error("Failed to refresh token:", error);
      return null;
    }
  }

async fetchSportbookBets  (dto)  {
  try {
    const token = Cookies.get("token");
    const response = await this.api.get(`${API_URL}/sb/getTickets`, {
      params: dto,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data?.data || [];
  } catch (error) {
    console.error("Error fetching transaction history:", error.response || error);
    throw new Error("Failed to fetch transaction history.");
  }
};
}

export default SportbookService;